export enum SortByOption {
  Name = 'name',
  Reference = 'customer_number',
}
